module.exports = __webpack_public_path__ + "static/media/group.72d3acd9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/group.png
// module id = 408
// module chunks = 0